import { render, staticRenderFns } from "./virtual.vue?vue&type=template&id=660a5975&scoped=true"
import script from "./virtual.vue?vue&type=script&lang=js"
export * from "./virtual.vue?vue&type=script&lang=js"
import style0 from "./virtual.vue?vue&type=style&index=0&id=660a5975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a5975",
  null
  
)

export default component.exports